var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<input class="content" placeholder="'+
((__t=( answers_placeholder ))==null?'':_.escape(__t))+
'" name="'+
((__t=( input_name ))==null?'':_.escape(__t))+
'[]" maxlength="100" type="text"/>\n';
}
return __p;
};
